import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

const navLinks = [
  { href: "/", label: "Home" },
  { href: "/location", label: "Die Location" },
  { href: "/preise", label: "Preise & Buchung" },
  { href: "/galerie", label: "Galerie" },
  { href: "/kontakt", label: "Kontakt" },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      className="bg-[#1C1C1E] border-t border-[#F2EDE8]/5 pt-16 pb-8"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          <div className="flex flex-col gap-5">
            <div className="flex items-center gap-3">
              <svg viewBox="0 0 44 44" fill="none" className="w-10 h-10 flex-shrink-0">
                <text
                  x="2"
                  y="36"
                  fontFamily="'Cormorant Garamond', serif"
                  fontSize="34"
                  fontWeight="600"
                  fill="#D4A843"
                >
                  77
                </text>
              </svg>
              <div>
                <p
                  className="text-[#F2EDE8] font-semibold tracking-[0.15em] text-sm"
                  style={{ fontFamily: "'Outfit', sans-serif" }}
                >
                  ATELIER 77
                </p>
                <p
                  className="text-[#D4A843]/60 text-xs italic"
                  style={{ fontFamily: "'Cormorant Garamond', serif" }}
                >
                  Art meets Party
                </p>
              </div>
            </div>
            <p
              className="text-[#A19D98] text-sm leading-relaxed"
              style={{ fontFamily: "'Outfit', sans-serif" }}
            >
              Eventlocation & Künstlerhof in Bochum-Laer. Betrieben von Künstler Klaus Teichmann.
            </p>
            <p
              className="text-[#C1440E]/70 text-xs tracking-widest uppercase"
              style={{ fontFamily: "'Outfit', sans-serif" }}
            >
              Bochum · Dortmund · Herne · Essen · Gelsenkirchen
            </p>
          </div>

          <div>
            <p
              className="text-[#F2EDE8]/30 text-[10px] tracking-[0.3em] uppercase mb-6"
              style={{ fontFamily: "'Outfit', sans-serif" }}
            >
              Navigation
            </p>
            <div className="flex flex-col gap-3">
              {navLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className="text-[#A19D98] hover:text-[#F2EDE8] text-sm transition-colors duration-200"
                  style={{ fontFamily: "'Outfit', sans-serif" }}
                  data-testid={`footer-nav-${link.href === "/" ? "home" : link.href.slice(1)}`}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <p
              className="text-[#F2EDE8]/30 text-[10px] tracking-[0.3em] uppercase mb-6"
              style={{ fontFamily: "'Outfit', sans-serif" }}
            >
              Kontakt
            </p>
            <div className="flex flex-col gap-4">
              <a
                href="tel:02349350002"
                className="flex items-start gap-3 text-[#A19D98] hover:text-[#C1440E] transition-colors group"
                data-testid="footer-phone"
              >
                <Phone size={13} className="mt-0.5 flex-shrink-0" />
                <span className="text-sm" style={{ fontFamily: "'Outfit', sans-serif" }}>
                  0234 / 935 000 2
                </span>
              </a>
              <a
                href="mailto:info@bochum-partyraum.de"
                className="flex items-start gap-3 text-[#A19D98] hover:text-[#C1440E] transition-colors group"
                data-testid="footer-email"
              >
                <Mail size={13} className="mt-0.5 flex-shrink-0" />
                <span className="text-sm" style={{ fontFamily: "'Outfit', sans-serif" }}>
                  info@bochum-partyraum.de
                </span>
              </a>
              <div className="flex items-start gap-3 text-[#A19D98]">
                <MapPin size={13} className="mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-sm" style={{ fontFamily: "'Outfit', sans-serif" }}>
                    Schattbachstraße 77
                  </p>
                  <p className="text-sm" style={{ fontFamily: "'Outfit', sans-serif" }}>
                    44803 Bochum (Laer)
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-[#F2EDE8]/5 py-8 text-center">
          <p
            className="text-[#D4A843]/40 text-xl italic"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            "Art meets Party — seit 1723."
          </p>
        </div>

        <div className="border-t border-[#F2EDE8]/5 pt-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p
            className="text-[#A19D98]/40 text-xs"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            © {year} Atelier 77 – Eventlocation & Künstlerhof Bochum. Klaus Teichmann.
          </p>
          <div className="flex items-center gap-6">
            <Link
              to="/impressum"
              className="text-[#A19D98]/40 hover:text-[#A19D98] text-xs transition-colors"
              data-testid="footer-impressum"
              style={{ fontFamily: "'Outfit', sans-serif" }}
            >
              Impressum
            </Link>
            <Link
              to="/datenschutz"
              className="text-[#A19D98]/40 hover:text-[#A19D98] text-xs transition-colors"
              data-testid="footer-datenschutz"
              style={{ fontFamily: "'Outfit', sans-serif" }}
            >
              Datenschutz
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
